import { Component, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { Router, NavigationExtras } from '@angular/router';
import { UserService } from '../user/user.service';
import { DataStorageService } from '../shared/data-storage.service';
import { RegisterdBillerResponse, RegistredBiller } from '../user/registered-biller-response';
import { TranslateService } from '@ngx-translate/core';
import { EkpayUser } from '../user/ekpay_user';

@Component({
  selector: 'app-user-regi-biller',
  templateUrl: './user-regi-biller.component.html',
  styleUrls: ['./user-regi-biller.component.css']
})
export class UserRegiBillerComponent implements OnInit {

  constructor(private userService: UserService,
    private logger: NGXLogger,
    private dataStorageService: DataStorageService,
    private translate: TranslateService,
    private router: Router) { }

  user: EkpayUser;
  registerBillerRes: RegisterdBillerResponse;
  registerBiller: RegistredBiller[];
  finalregisterBiller: RegistredBiller[];
  selectedRegistredBiller: RegistredBiller;
  subscription: Subscription;
  finalBilerIds: any[];
  lang: string;

  ngOnInit() {
    this.subscription = this.dataStorageService.langData$.subscribe((data) => {
      this.lang = data;
      if (this.lang == '' || this.lang == null) {
        this.lang = localStorage.getItem("lang");
      }
      this.translate.use(this.lang);
    })
    this.user = new EkpayUser();
    this.subscription = this.dataStorageService.userData$.subscribe((data) => {
      this.user = data as EkpayUser;
      localStorage.setItem("user", JSON.stringify(this.user));
    });

    if (localStorage.getItem("user") == undefined || localStorage.getItem("user") == 'undefined') {
      this.user = JSON.parse(localStorage.getItem("sessuser")) as EkpayUser;
    } else {
      this.user = JSON.parse(localStorage.getItem("user")) as EkpayUser;
      localStorage.setItem("sessuser", JSON.stringify(this.user));
    }
    this.user = JSON.parse(localStorage.getItem("sessuser")) as EkpayUser;
    this.logger.debug("user regi bill..." + JSON.stringify(this.user));
    if (this.user != null) {
      this.getRegiBiller();
    }
  }

  getRegiBiller() {
    const set = new Set();
    if (this.user.ekpay_id != undefined) {
      this.userService.getRegisteredBillers(this.user.ekpay_id).subscribe(data => {
        this.registerBillerRes = new RegisterdBillerResponse();
        this.registerBillerRes = data as RegisterdBillerResponse;
        if (this.registerBillerRes.response == 'success') {
          this.finalregisterBiller = [];
          this.registerBiller = this.registerBillerRes.registred_billers;
          this.logger.debug("register biller..." + JSON.stringify(this.registerBiller));
          this.finalBilerIds = [];
          this.registerBiller.forEach(data => {
            if (!this.finalBilerIds.includes(data.biller_id)) {
              this.finalBilerIds.push(data.biller_id);
              this.finalregisterBiller.push(data);
            }
          });
        } else {
          this.finalregisterBiller = null;
        }
        this.logger.debug("final biller...." + JSON.stringify(this.finalregisterBiller));
      });
    }
  }

  redirecToBiller(i) {
    let parmval = "";
    let parmmob = "";
    this.registerBiller.forEach(data => {
      if (data.regs_id == i) {
        this.selectedRegistredBiller = data;
      }
    });

    this.logger.debug("select biller...." + JSON.stringify(this.selectedRegistredBiller));

    if (this.selectedRegistredBiller.service_name == 'Electricity') {
      if (this.selectedRegistredBiller.biller_name == 'pdb' || this.selectedRegistredBiller.biller_name == 'dpdc') {
        this.registerBiller.forEach(data => {
          if (this.selectedRegistredBiller.biller_id == data.biller_id) {
            parmval = parmval + data.bill_accno + "~";
          }
        });
        let navigationExtras: NavigationExtras = {
          queryParams: {
            "jgszcta": this.selectedRegistredBiller.biller_name,
            "kitxztnp": parmval
          }
        }
        this.router.navigate(["payment/bill-payment"], navigationExtras);
      } else if (this.selectedRegistredBiller.biller_name == 'breb') {
        this.registerBiller.forEach(data => {
          if (this.selectedRegistredBiller.biller_id == data.biller_id) {
            parmval = parmval + data.bill_no + "~";
          }
        });
        let navigationExtras: NavigationExtras = {
          queryParams: {
            "jgszcta": this.selectedRegistredBiller.biller_name,
            "billno": parmval
          }
        }
        this.router.navigate(["payment/bill-payment"], navigationExtras);
      } else if (this.selectedRegistredBiller.biller_name == 'desco') {
        this.registerBiller.forEach(data => {
          if (this.selectedRegistredBiller.biller_id == data.biller_id) {
            parmval = parmval + data.bill_no + "~";
          }
        });
        let navigationExtras: NavigationExtras = {
          queryParams: {
            "jgszcta": this.selectedRegistredBiller.biller_name,
            "billno": parmval
          }
        }
        this.router.navigate(["payment/bill-payment"], navigationExtras);
      }

    } else if (this.selectedRegistredBiller.service_name == 'Gas') {
      this.registerBiller.forEach(data => {
        // alert("" + this.selectedRegistredBiller.biller_id + "==" + data.biller_id);
        if (this.selectedRegistredBiller.biller_id == data.biller_id) {
          parmval = parmval + data.bill_accno + "~";
          parmmob = parmmob + data.bill_mobile_no + "~";
        }
      });
      let navigationExtras: NavigationExtras = {
        queryParams: {
          "jgszcta": this.selectedRegistredBiller.biller_name,
          "kitxztnp": parmval,
          "kitmobxcd": parmmob
        }
      };
      this.router.navigate(["payment/gas"], navigationExtras);
    } else if (this.selectedRegistredBiller.service_name.toLowerCase() == 'water') {
      this.registerBiller.forEach(data => {
        if (this.selectedRegistredBiller.biller_id == data.biller_id) {
          parmval = parmval + data.bill_no + "~";
        }
      });
      let navigationExtras: NavigationExtras = {
        queryParams: {
          "jgszcta": this.selectedRegistredBiller.biller_name,
          "billno": parmval
        }
      }
      this.router.navigate(["payment/water"], navigationExtras);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/user-regi-biller/user-regi-biller.component.ts